<div class="container-fluid mb-5 px-3">
    <div class="mt-3 d-flex justify-content-between">
        <div class="font-weight-bold">
            <h1>
                <span *ngIf="this.selectedOrganizationName">
                    {{ this.selectedOrganizationName }}
                </span>
                Properties
            </h1>
        </div>
        <div class="d-flex mt-2 me-1">
            <button mat-raised-button class="action-button d-flex col-auto align-items-center"
                (click)="onNewPropertyClick()">
                <mat-icon>add</mat-icon>
                Add Property
            </button>
        </div>
    </div>
    <mat-card class="mt-3 pb-5">
        <div class="row justify-content-center">
            <div class="col-12" style="overflow-x: auto; overflow-y: hidden">
                <app-data-table 
                    [component]="'Properties'"
                    (searchEvent)="onSearchEvent($event)" 
                    (pageEvent)="onPageEvent($event)"
                    (sortEvent)="onSortEvent($event)"
                    [dataSource]="dataSource" 
                    [displayedColumns]="displayedColumns" 
                    [tableLength]="tableLength" 
                    [pageSize]="pageSize" 
                    [pageNumber]="pageNumber"
                    [showPaginator]="true"
                    [filterDefinitions]="filterDefinitions"
                    [displayLoadingIndicator]="loading" 
                    [getStatusColor]="getPropertyStatusColor"
                    [initialKeyword]="this.initialKeyword"
                    [initialSort]="this.initialSort"
                    [initialPageSize]="this.initialPageSize"
                    [initialPageNumber]="this.initialPageNumber"
                    [rowClicked]="rowClicked"
                    (massUpdatePropertyStatusEvent)="onPropertyUpdateStatusEvent($event)" 
                    (massUpdatePropertyPolicyEvent)="onPropertyUpdatePolicyEvent($event)">
                </app-data-table>
            </div>
        </div>
    </mat-card>
</div>